import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || '/bazi/api';

const api = axios.create({
  baseURL: API_URL,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  },
  // Keep enough headroom for slower cold starts and follow-up chat calls.
  timeout: 180000,
});

export const calculateBazi = async (data) => {
  try {
    console.log('Sending request to:', `${API_URL}/calculate`);
    const response = await api.post('/calculate', data);
    return response.data;
  } catch (error) {
    console.error('API Error:', error);
    throw error;
  }
};

export const calculateBaziOnly = async (data) => {
  try {
    const response = await api.post('/bazi', data);
    return response.data;
  } catch (error) {
    console.error('API Error:', error.response || error);
    throw error;
  }
};

export const calculateCompatibility = async (data) => {
  try {
    const response = await api.post('/compatibility', data);
    return response.data;
  } catch (error) {
    console.error('API Error:', error.response || error);
    throw error;
  }
};

export const calculateNaming = async (data) => {
  try {
    const response = await api.post('/naming', data);
    return response.data;
  } catch (error) {
    console.error('API Error:', error.response || error);
    throw error;
  }
};

export const calculateDateSelection = async (data) => {
  try {
    const response = await api.post('/date-selection', data);
    return response.data;
  } catch (error) {
    console.error('API Error:', error.response || error);
    throw error;
  }
};

export const getMember = async () => {
  const response = await api.get('/member/me');
  return response.data;
};

export const saveMemberProfile = async (data) => {
  const response = await api.post('/member/profile', data);
  return response.data;
};

export const getMemberReport = async (lang) => {
  const response = await api.get('/member/report', { params: { lang } });
  return response.data;
};

export const getMemberCalendar = async (lang) => {
  const response = await api.get('/member/calendar', { params: { lang } });
  return response.data;
};

export const sendMemberChat = async (data) => {
  const response = await api.post('/member/chat', data);
  return response.data;
};

export const markMemberWhatsappStarted = async () => {
  const response = await api.post('/member/whatsapp-started');
  return response.data;
};

export const startStripeCheckout = async () => {
  const response = await api.post('/stripe/create-checkout-session');
  return response.data;
};

export const startStripeBillingPortal = async () => {
  const response = await api.post('/stripe/create-billing-portal-session');
  return response.data;
};

export const logoutMember = async () => {
  const response = await api.post('/auth/logout');
  return response.data;
};

export default api;
